import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import config from '../../../../config';
import TableBuilder from '../../../../shared/components/table/TableBuilder';
import {
  formatDecimalToFixedTwoPercent, currencyFormatter, formatNumberDefaultToZero,
} from '../../../../shared/components/table/functions';

const apiUrl = config.isProdEnv ? config.serverProdUrl : config.serverDevUrl;

class TopTenMarketShareTable extends PureComponent {
  static propTypes = {
    firstTableId: PropTypes.string.isRequired,
    secondTableId: PropTypes.string.isRequired,
    sellerAccountId: PropTypes.number.isRequired,
    parentAccountId: PropTypes.number.isRequired,
    setPageData: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);

    const {
      firstTableId, secondTableId, sellerAccountId, parentAccountId,
    } = this.props;

    this.state = {
      columnDefs: [
        {
          field: 'brand',
          headerName: 'Brand',
          chartDataType: 'category',
        },
        {
          headerName: 'First Date',
          children: [
            {
              field: 'asin_count',
              headerName: 'Count of ASIN',
              chartDataType: 'series',
            },
            {
              field: 'subcat_rank',
              headerName: 'AVG Sub Category Rank',
              chartDataType: 'series',
              valueFormatter: formatNumberDefaultToZero,
            },
            {
              field: 'cat_rank',
              headerName: 'AVG Category Rank',
              valueFormatter: formatNumberDefaultToZero,
              chartDataType: 'series',
            },
            {
              field: 'units',
              headerName: 'Units',
              chartDataType: 'series',
            },
            {
              field: 'revenue',
              headerName: 'Revenue',
              valueFormatter: currencyFormatter,
              chartDataType: 'series',
            },
          ],
        },
        {
          headerName: 'Second Date',
          children: [
            {
              field: 'second_asin_count',
              headerName: 'Count of ASIN',
              chartDataType: 'series',
            },
            {
              field: 'second_subcat_rank',
              headerName: 'AVG Sub Category Rank',
              valueFormatter: formatNumberDefaultToZero,
              chartDataType: 'series',
            },
            {
              field: 'second_cat_rank',
              headerName: 'AVG Category Rank',
              valueFormatter: formatNumberDefaultToZero,
              chartDataType: 'series',
            },
            {
              field: 'second_units',
              headerName: 'Units',
              chartDataType: 'series',
            },
            {
              field: 'second_revenue',
              headerName: 'Revenue',
              valueFormatter: currencyFormatter,
              chartDataType: 'series',
            },
          ],
        },
        {
          headerName: 'Delta',
          children: [
            {
              field: 'delta_asin_count',
              headerName: 'Count of ASIN',
              valueFormatter: formatDecimalToFixedTwoPercent,
              chartDataType: 'series',
            },
            {
              field: 'delta_subcat_rank',
              headerName: 'AVG Sub Category Rank',
              valueFormatter: formatDecimalToFixedTwoPercent,
              chartDataType: 'series',
            },
            {
              field: 'delta_cat_rank',
              headerName: 'AVG Category Rank',
              valueFormatter: formatDecimalToFixedTwoPercent,
              chartDataType: 'series',
            },
            {
              field: 'delta_units',
              headerName: 'Units',
              valueFormatter: formatDecimalToFixedTwoPercent,
              chartDataType: 'series',
            },
            {
              field: 'delta_revenue',
              headerName: 'Revenue',
              valueFormatter: currencyFormatter,
              chartDataType: 'series',
            },
          ],
        },
      ],
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        cellStyle: (params) => {
          if (params.value < 0.00) {
            return { color: 'red' };
          }
          return null;
        },
      },
      showFooter: false,
      enableCharts: true,
      enableRangeSelection: true,
      apiQueryParams: `firstTableId=${firstTableId}&secondTableId=${secondTableId}&sellerAccountId=${sellerAccountId}&parentAccountId=${parentAccountId}`,
    };
  }

  static getDerivedStateFromProps(props) {
    if (props.firstTableId && props.secondTableId) {
      return {
        apiQueryParams: `firstTableId=${props.firstTableId}&secondTableId=${props.secondTableId}&sellerAccountId=${props.sellerAccountId}&parentAccountId=${props.parentAccountId}`,
      };
    }
    return null;
  }

  render() {
    const {
      columnDefs, defaultColDef, showFooter, enableCharts, enableRangeSelection, apiQueryParams,
    } = this.state;

    const { setPageData } = this.props;

    const apiEndPoint = `${apiUrl}/vendors/market-share-brands`;

    return (
      <TableBuilder
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        apiEndPoint={apiEndPoint}
        apiQueryParams={apiQueryParams}
        showFooter={showFooter}
        enableCharts={enableCharts}
        enableRangeSelection={enableRangeSelection}
        parentSetData={setPageData}
      />
    );
  }
}

export default TopTenMarketShareTable;
